<template>
  <section>
    <transition name="fade" mode="out-in">
      <router-view :key="$route.fullPath" />
    </transition>
    <ScrollToTop />
  </section>
</template>

<script>
import ScrollToTop from './components/ScrollToTop.vue';

export default {
  name: "App",
  components: {
    ScrollToTop
  }
};
</script>

<style>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

html {
  scroll-behavior: smooth;
}

/* Fix Chrome's fixed-position bug */
@supports (-webkit-touch-callout: none) {
  html, body {
    position: fixed;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
}

/* Clean fade + lift transition for route changes */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.4s ease-in-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

.before-fade {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 1s ease, transform 1s ease;
}

.fade-in-visible {
  opacity: 1;
  transform: translateY(0);
}

</style>
